import React from 'react'
import { BetterComponent } from '../../../components/better-component/better-component'
import { BetterSelect } from '../../../components/better-select/better-select'
import { IFilterBuilderProps } from '../interfaces/filter-builder'
import { getClassNames } from '../../../_utils/classnames'
import { AppService } from '../../../services'
import { Container } from 'typescript-ioc/es5'
import { CampaignSearchBar } from '../../../components/campaign-search-bar/campaign-search-bar'
import './style/campaign-id.filter-builder.scss'
import clone from 'clone'

export class CampaignIdFilterBuilder extends BetterComponent<IFilterBuilderProps, any> {
    protected appService: AppService

    constructor(props: IFilterBuilderProps) {
        super(props)

        this.appService = Container.get(AppService)
    }

    public render(): React.ReactNode {
        return (
            <>
                <div className={getClassNames('filter', 'cid-filter')}>
                    <div className={getClassNames('filter-wrapper')}>
                        <div className={getClassNames('filter-display')}>
                            <span className="filter-op">{this.currentOperatorDisplay}</span>
                        </div>
                        <div className={getClassNames('filter-editor')}>
                            <div className="filter-op">
                                <BetterSelect
                                    size="small"
                                    disableSearch={true}
                                    dropdownClassName="filter-op-dropdown"
                                    options={[
                                        { value: 'IN', label: 'is' },
                                        { value: 'NOT_IN', label: 'is not' },
                                    ]}
                                    defaultValue={['IN']}
                                    value={this.currentValue.operator}
                                    onChange={(operator: string) => {
                                        this.handleChange({ operator })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="filter-val">
                            <CampaignSearchBar
                                className="campaign-search"
                                mode={this.props.mode === 'display' ? 'display' : 'search'}
                                value={this.currentValueStr}
                                placeholder="Search ID or Name"
                                onChange={this.handleCampaignChange}
                                getDropdownContainer={this.appService.getAppContainer}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    protected get currentValue(): any {
        const propsValue: any = this.props.value || {}
        return clone({
            field: 'CAMPAIGN_ID',
            operator: propsValue.operator || 'IN',
            value: propsValue.value,
        })
    }

    protected get currentOperatorDisplay(): any {
        return this.currentValue.operator === 'IN' ? 'is' : 'is not'
    }

    protected get currentValueStr(): any {
        const value = this.currentValue.value || undefined
        return Array.isArray(value) ? value.join(',') : value
    }

    protected handleCampaignChange = (promptId: number) => {
        this.handleChange({ value: !promptId ? undefined : [promptId] })
    }

    protected handleChange(config: any): any {
        if (!!config) {
            this.props.onChange({
                ...this.props.value,
                ...config,
                field: 'CAMPAIGN_ID',
            })
        } else {
            this.props.onChange()
        }
    }
}
